import React from "react";
import { Popover } from 'react-bootstrap'


export const renderCoverageTooltip = (coverageCode: string, props: any) => {
    console.log(coverageCode);
    switch (coverageCode) {
        case "BI":
            return <Popover id="coveragePopoverBI" className="coverage-tooltip" {...props}>
                <Popover.Title as="h3">Bodily Injury Insurance Coverage (BI)</Popover.Title>
                <Popover.Content>
                    Bodily Injury (BI) liability coverage pays claims for other people that are injured or killed in an accident that you are legally responsible. This coverage will also cover your legal defense if you are sued as a result of an accident. The first number listed is the maximum amount that can be paid per injured person. The second number is the maximum amount that can be paid out to all persons injured in a single accident.
                </Popover.Content>
            </Popover>;
        case "PD":
            return <Popover id="coveragePopoverPD" className="coverage-tooltip" {...props}>
                <Popover.Title as="h3">Property Damage (PD)</Popover.Title>
                <Popover.Content>
                    Property Damage (PD) liability coverage pays for damage to other people's property that results from an accident for which you are legally responsible. This coverage does not cover damage to your own vehicle.
                </Popover.Content>
            </Popover>;
        case "COLL":
            return <Popover id="coveragePopoverCOLL" className="coverage-tooltip" {...props}>
                <Popover.Title as="h3">Collision (COLL)</Popover.Title>
                <Popover.Content>
                    Collision (COLL) coverage pays for repairs or to replace your vehicle when it is damaged in a collision with another vehicle or some other object. This coverage does not pay for damage that you cause to another person's vehicle in an accident. Often, lienholders/lessors will require you to carry this coverage on your vehicle.
                </Popover.Content>
            </Popover>;
        case "COMP":
            return <Popover id="coveragePopoverCOMP" className="coverage-tooltip" {...props}>
                <Popover.Title as="h3">Comprehensive (COMP)</Popover.Title>
                <Popover.Content>
                    Comprehensive (COMP) coverage pays for repairs or to replace your vehicle when it when the damage is cause by something other than a collision. This may include damage from vandalism, fire, hail, wind, theft, or some other peril. Often, lienholders/lessors will require you to carry this coverage on your vehicle.
                </Popover.Content>
            </Popover>;
        case "MED":
            return <Popover id="coveragePopoverMED" className="coverage-tooltip" {...props}>
                <Popover.Title as="h3">Medical Payments</Popover.Title>
                <Popover.Content>
                    Medical Payments coverage helps pay for costs associated with injuries to you and your passengers resulting from a covered incident, regardless of who is at fault. It also covers funeral expenses and your own medical expenses if you are hit by a car while walking or biking. This coverage has a single “limit”, which is the maximum amount we will pay per person in a single covered incident.
                </Popover.Content>
            </Popover>;
        case "UM":
            return <Popover id="coveragePopoverUM" className="coverage-tooltip" {...props}>
                <Popover.Title as="h3">Uninsured Bodily Injury</Popover.Title>
                <Popover.Content>
                    Uninsured Motorist Bodily Injury coverage pays for costs associated with injuries to you and other people in your vehicle resulting from a covered incident caused by a driver with no insurance or not enough insurance. This coverage has two parts (e.g. $15,000/$30,000) – the first number represents the maximum amount we will pay per person in a single covered incident; the second number represents the maximum amount that we will pay per covered incident regardless of the number of injured parties.
                </Popover.Content>
            </Popover>;
    }

    return <div></div>;
};